import gql from "graphql-tag";

export const POOL_NUMBER_DETAILS = gql`
  fragment PoolNumberDetails on PoolNumber {
    fbGraphId
    phoneNumber
    uuid
  }
`;
